import React from "react";
import { Box, Typography } from "@mui/material";
import moment from "moment";

const AgreementCard = ({ agreement }) => {
  return (
    <Box
      sx={{
        border: "1px solid lightgrey",
        borderRadius: "10px",
        padding: "10px",
        maxWidth: "400px",
      }}
    >
      <Typography variant="h6" component={"span"}>
        Agreement Terms
      </Typography>

      <Box my={1}>
        <Typography component={"span"}>Name Of Supplier : </Typography>
        <Typography component={"span"}>{agreement?.nameOfSupplier} </Typography>
      </Box>
      <Box my={1}>
        <Typography component={"span"}>Date Of Agreement : </Typography>
        <Typography component={"span"}>
          {moment(agreement?.dateOfAgreement)?.format("DD MMM YYYY")}
        </Typography>
      </Box>
      <Box my={1}>
        <Typography component={"span"}>Term Of Agreement : </Typography>
        <Typography component={"span"}>
          {agreement?.daysOfAgreement / 30} months
        </Typography>
      </Box>
      <Box my={1}>
        <Typography component={"span"}>Number Of Refresh Cycles : </Typography>
        <Typography component={"span"}>
          {agreement?.numberOfRefreshCycles}
        </Typography>
      </Box>
    </Box>
  );
};

export default AgreementCard;
